export const SITE = {
  brand: "Coreline Heavy Haul & Hotshot",
  short: "Coreline",
  tagline: "Heavy Duty. On Time. Every Time.",
  domain: "corelinehaul.com",
  contact: {
    phone: "(780) 229-8945",
    email: "dispatch@corelinehaul.com",
    address: "3460 91 Street, Edmonton, AB T6E 5R1",
    serviceArea: "Western Canada & Cross-Border USA",
    hours: "24 / 7 Dispatch",
  },
  assets: {
    logo: "https://customer-assets.emergentagent.com/job_d314898f-4a97-4575-b5be-5789b2ef07b5/artifacts/fb7e1rwg_ChatGPT%20Image%20May%2026%2C%202026%2C%2010_45_48%20AM.png",
    truck: "https://customer-assets.emergentagent.com/job_coreline-trucks/artifacts/eohvetb0_Design.png",
    truckFront: "https://customer-assets.emergentagent.com/job_coreline-trucks/artifacts/ac2k0yzm_2.png",
    mapBg: "https://static.prod-images.emergentagent.com/jobs/d314898f-4a97-4575-b5be-5789b2ef07b5/images/a86cd4796108c8700745942f8373dbf9d1eec3484da2bb92810236b5e19d8529.png",
    texture: "https://static.prod-images.emergentagent.com/jobs/d314898f-4a97-4575-b5be-5789b2ef07b5/images/d61daaaa77f0e1c7f16eadc244d3daaeb3cfec38ba2c50077c3e320455756782.png",
    cargo: "https://images.unsplash.com/photo-1763950865631-4ca11bebe017?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjY2NzV8MHwxfHNlYXJjaHwyfHxzdGVlbCUyMHBpcGVzJTIwaW5kdXN0cmlhbCUyMGNhcmdvfGVufDB8fHx8MTc3OTk5MzgyM3ww&ixlib=rb-4.1.0&q=85",
    highway: "https://images.unsplash.com/photo-1776521905669-97fa944bf30c?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1NDh8MHwxfHNlYXJjaHwxfHxzZW1pJTIwdHJ1Y2slMjBoaWdod2F5fGVufDB8fHx8MTc3OTk5MzgyM3ww&ixlib=rb-4.1.0&q=85",
  },
  services: [
    {
      key: "heavy-haul",
      title: "Heavy Haul",
      blurb: "Oversized & overweight loads moved with precision permitting and pilot coordination.",
      points: ["Oversize / Overweight", "Multi-axle Trailers", "Permit & Pilot Cars"],
    },
    {
      key: "hotshot",
      title: "Hotshot Delivery",
      blurb: "Time-critical freight, dispatched fast — when downtime is not an option.",
      points: ["24/7 Dispatch", "Direct Drive", "Same-Day & Expedited"],
    },
    {
      key: "equipment",
      title: "Equipment Hauling",
      blurb: "Construction, oilfield, agricultural — heavy iron moved safely site-to-site.",
      points: ["Skids & Dozers", "Oilfield Modules", "Site-to-Site"],
    },
    {
      key: "flatbed",
      title: "Flatbed Transport",
      blurb: "Steel, pipe, lumber, machinery — strapped, tarped, and delivered on time.",
      points: ["Tarped Loads", "Steel & Pipe", "Lumber & Machinery"],
    },
    {
      key: "dry-van",
      title: "Dry Van",
      blurb: "Enclosed dry van freight — palletized goods, packaged products, and general LTL/FTL.",
      points: ["Palletized Freight", "Weather-Protected", "LTL & FTL"],
    },
    {
      key: "reefer",
      title: "Reefer",
      blurb: "Temperature-controlled refrigerated transport for perishables and cold-chain freight.",
      points: ["Temp-Controlled", "Cold Chain", "Perishables"],
    },
    {
      key: "cross-border",
      title: "Cross-Border CA / US",
      blurb: "Canada–US freight with full customs paperwork, bonded carriers, and tracking.",
      points: ["Customs Cleared", "Bonded", "Real-Time Tracking"],
    },
  ],
  stats: [
    { value: "24/7", label: "Dispatch Available" },
    { value: "CA / US", label: "Cross-Border Ready" },
    { value: "0", label: "Shortcuts Taken" },
  ],
  trust: [
    "Fully Insured & Compliant",
    "Modern, Maintained Fleet",
    "Experienced Operators",
    "Transparent Pricing",
  ],
};

export const SERVICE_OPTIONS = SITE.services.map((s) => s.title);
